import React from 'react';

export default function SecFilingPriorityPill({ isCritical = false }) {
  const critical = Boolean(isCritical);
  const label = critical ? 'Critical' : 'Non-critical';

  return (
    <span
      className={[
        'sec-filing-insights-type-pill',
        critical
          ? 'sec-filing-insights-type-pill--critical'
          : 'sec-filing-insights-type-pill--non-critical',
      ].join(' ')}
    >
      {label}
    </span>
  );
}
